import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, SelectProps, Table, Tag} from "antd";
import Colors from "../../../styles/Colors";
import {BiDownload, BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye, BsEyeSlash} from "react-icons/bs";
import PlantillaModal from "../../PlantillaModal";
import ComandaGenerada from "../../../model/menudesign/comandes/ComandaGenerada";
import {format} from "date-fns";
import {GetComandesGenerades} from "../../../dao/menudesign/comandes/GetComandesGenerades";
import {GetComandesGeneradesIdPdf} from "../../../dao/menudesign/comandes/GetComandesGeneradesIdPdf";
import toast from "react-hot-toast";

const GestorComandes = () => {
    const titol: string = "Gestor de Comandes";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<ComandaGenerada[]>([]);
    const [elementSelected, setElementSelected] = useState<ComandaGenerada>(new ComandaGenerada());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisEdicio = user.pagines.find(pagina => pagina.descripcio === "Gestió de Comandes" && pagina.tipus === 1);


    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkDades();
        }
        
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetComandesGenerades(page);
        setDades(dades);
        await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await DeleteComandaGenerada(id, page);
        //await checkDades();
    }

    function afegirElement(element: ComandaGenerada) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: ComandaGenerada) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };
    async function handleDownload (id: string)  {
        setLoading(true);
        const documentUrl = await GetComandesGeneradesIdPdf(page, id);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `ComandaGenerada${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(false);
    };

    function setNameFilters(elements: ComandaGenerada[]) {
        if (elements?.length > 0) {
            const uniqueNonEmptyNames = Array.from(new Set(elements
                .map((element) => element.proveidor)
                .filter((name) => name !== '')));

            const ingredientNames = uniqueNonEmptyNames.map((name) => ({
                text: name,
                value: name,
            }));

            setNomFiltres(ingredientNames);
        }
    }

    function togleEditar(id: number) {

    }

    const columns: ColumnsType<ComandaGenerada> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'proveidor',
            title: 'Proveidor',
            dataIndex: 'proveidor',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 10,
            responsive: ['lg'],
            render: (estat, ele) => (
                ele.estat === 0 ? <Tag color={"orange"}>Comanda generada (Escoles)</Tag> :
                    ele.estat === 1 ? <Tag color={"blue"}>Pendent de rebre (Magatzem)</Tag> :
                        ele.estat === 2 ? <Tag color={"cyan"}>Volcada a l'stock</Tag> :
                            ele.estat === 5 ? <Tag color={"coral"}>eliminada</Tag> :
                                <Tag color={"green"}>Altres</Tag>
            )
        },
        {
            key: 'creacio',
            title: 'Data de Creació',
            dataIndex: 'creacio',
            width: 10,
            render: (estat, ele) => (
                <Tag color={"green"}>{format(new Date(ele.creacio), 'dd-MM-yyyy')}</Tag>
            )
        },
        {
            key: 'inici',
            title: "Data d'inici",
            dataIndex: 'inici',
            width: 10,
            responsive: ['lg'],
            render: (estat, ele) => (
                <Tag>{format(new Date(ele.inici), 'dd-MM-yyyy')}</Tag>
            )
        },
        {
            key: 'fin',
            title: 'Data final',
            dataIndex: 'fin',
            width: 10,
            responsive: ['lg'],
            render: (estat, ele) => (
                <Tag>{format(new Date(ele.fin), 'dd-MM-yyyy')}</Tag>
            )
        },
        {
            key: 'setmana',
            title: 'Setmana',
            dataIndex: 'setmana',
            width: 10,
            responsive: ['lg'],
            render: (estat, ele) => (
                <Tag>W-{ele.setmana}</Tag>
            )
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions',
            width: 100,
            render: (estat, ele) => (
                <>
                    <Button title={"Descarregar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => handleDownload(ele.id+"")}><BiDownload/></Button>{" "}
                    <Button title={ele.revisada ? "Revisada" : "No Revisada"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => togleEditar(ele.id)}>{(ele.revisada === 0 && (<BsEye/>)) || (ele.revisada !== 1 && (<BsEyeSlash/>))}
                    </Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<ComandaGenerada> = {
        loading
    };

    const onChange: TableProps<ComandaGenerada>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };


    type TagRender = SelectProps['tagRender'];
    const tagRender: TagRender = (props) => {
        const {label, value, closable, onClose} = props;
        const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault();
            event.stopPropagation();
        };
        const colors = ["orange", "blue", "cyan", "green"];
        return (
            <Tag
                color={colors[value]}
                onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose}
                style={{marginRight: 3}}
            >
                {label}
            </Tag>
        );
    };

    if (isLoggedIn) {
        return (
            <div>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"} style={{alignItems: "center", display: "flex"}}>
                            {permisEdicio &&
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(new ComandaGenerada())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                pagination={{pageSize: 100}}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"GESTIOCOMANDES"} pagina={page}/>
                    {nouElement && (
                        <PlantillaModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default GestorComandes;
